import {
    useEffect,
    useState
} from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function PurchaseReturns() {

    const navigate =
        useNavigate();

    const [purchaseReturns,
        setPurchaseReturns] =
        useState([]);

    const [page,
        setPage] =
        useState(1);

    const [pages,
        setPages] =
        useState(1);

    const [search,
        setSearch] =
        useState("");

    useEffect(() => {

        loadPurchaseReturns();

    }, [
        page,
        search
    ]);

    const loadPurchaseReturns =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(

                        `/purchase-returns?page=${page}&search=${search}`,

                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }

                    );

                setPurchaseReturns(
                    res.data.purchaseReturns
                );

                setPages(
                    res.data.pages
                );

            } catch (err) {

                console.log(err);

            }

        };

    const deletePurchaseReturn =
        async (id) => {

            if (
                !window.confirm(
                    "Delete Purchase Return?"
                )
            ) return;

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                await API.delete(

                    `/purchase-returns/${id}`,

                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }

                );

                loadPurchaseReturns();

            } catch (err) {

                console.log(err);

            }

        };

    return (

        <div>

            {/* Header */}

            <div
                className="
                flex
                flex-col
                md:flex-row
                md:justify-between
                md:items-center
                gap-4
                mb-6
                "
            >

                <div>

                    <h1
                        className="
                        text-4xl
                        font-bold
                        "
                    >
                        Purchase Returns
                    </h1>

                    <p
                        className="
                        text-gray-400
                        mt-2
                        "
                    >
                        Manage Returned Purchases
                    </p>

                </div>

                {hasPermission("purchase_return.add") && (
                    <Link
                        to="/admin/purchase-returns/add"
                        className="
                    bg-yellow-500
                    text-black
                    px-6
                    py-3
                    rounded-xl
                    font-semibold
                    "
                    >
                        Add Purchase Return
                    </Link>
                )}

            </div>

            {/* Search */}

            <div
                className="
                mb-6
                "
            >

                <input
                    type="text"
                    placeholder="Search Return No / Supplier..."
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                    className="
                    w-full
                    md:w-96
                    p-3
                    rounded-xl
                    bg-[#111]
                    border
                    border-yellow-500/20
                    "
                />

            </div>

            {/* Mobile Cards */}

            <div
                className="
                md:hidden
                space-y-4
                "
            >
                {purchaseReturns.length > 0 ? (

                    purchaseReturns.map(
                        (item) => (

                            <div
                                key={item.id}
                                className="
                bg-[#111]
                border
                border-yellow-500/20
                rounded-2xl
                p-5
                "
                            >

                                <div
                                    className="
                    flex
                    justify-between
                    items-center
                    "
                                >

                                    <div>

                                        <h3
                                            className="
                            text-lg
                            font-bold
                            "
                                        >
                                            {item.return_no}
                                        </h3>

                                        <p
                                            className="
                            text-gray-400
                            text-sm
                            "
                                        >
                                            {new Date(item.created_at).toLocaleString()}
                                        </p>

                                    </div>

                                    <span
                                        className="
                        bg-orange-500/20
                        text-orange-400
                        px-3
                        py-1
                        rounded-full
                        text-sm
                        "
                                    >
                                        Purchase Return
                                    </span>

                                </div>

                                <div
                                    className="
                    mt-5
                    space-y-3
                    "
                                >

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >
                                        <span className="text-gray-400">
                                            Supplier
                                        </span>

                                        <span>
                                            {item.supplier_name}
                                        </span>
                                    </div>

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >
                                        <span className="text-gray-400">
                                            Wallet
                                        </span>

                                        <span>
                                            {item.wallet_name}
                                        </span>
                                    </div>

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >
                                        <span className="text-gray-400">
                                            Phone
                                        </span>

                                        <span>
                                            {item.phone}
                                        </span>
                                    </div>

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >
                                        <span className="text-gray-400">
                                            Total
                                        </span>

                                        <span
                                            className="
                            font-bold
                            text-green-400
                            "
                                        >
                                            ₹
                                            {Number(
                                                item.grand_total
                                            ).toFixed(2)}
                                        </span>
                                    </div>

                                </div>

                                <div
                                    className="
                    grid
                    grid-cols-3
                    gap-2
                    mt-6
                    "
                                >

                                    {hasPermission("purchase_return.view") && (
                                        <>
                                            <button
                                                onClick={() =>
                                                    navigate(
                                                        `/admin/purchase-returns/view/${item.id}`
                                                    )
                                                }
                                                className="
                        bg-blue-500
                        py-2
                        rounded-xl
                        "
                                            >
                                                View
                                            </button>
                                        </>
                                    )}

                                    {hasPermission("purchase_return.delete") && (
                                        <button
                                            onClick={() =>
                                                deletePurchaseReturn(
                                                    item.id
                                                )
                                            }
                                            className="
                        bg-red-500
                        py-2
                        rounded-xl
                        "
                                        >
                                            Delete
                                        </button>
                                    )}

                                </div>

                            </div>

                        )
                    )

                ) : (

                    <div
                        className="
        bg-[#111]
        rounded-2xl
        p-8
        text-center
        text-gray-400
        "
                    >
                        No Purchase Returns Found
                    </div>

                )}

            </div>

            {/* Desktop Table */}

            <div
                className="
    hidden
    md:block
    bg-[#111]
    rounded-2xl
    overflow-hidden
    "
            >
                <div
                    className="
    overflow-x-auto
    "
                >

                    <table
                        className="
        w-full
        "
                    >

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >

                                <th className="p-4 text-left">
                                    Return No
                                </th>

                                <th className="p-4 text-left">
                                    Supplier
                                </th>

                                <th className="p-4 text-left">
                                    Wallet
                                </th>

                                <th className="p-4 text-left">
                                    Date
                                </th>

                                <th className="p-4 text-left">
                                    Amount
                                </th>

                                <th className="p-4 text-left">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                purchaseReturns.length > 0 ? (

                                    purchaseReturns.map(
                                        (item) => (

                                            <tr
                                                key={item.id}
                                                className="
                                border-b
                                border-yellow-500/10
                                hover:bg-yellow-500/5
                                "
                                            >

                                                <td className="p-4 font-semibold">
                                                    {item.return_no}
                                                </td>

                                                <td className="p-4">
                                                    {item.supplier_name}
                                                </td>

                                                <td className="p-4">
                                                    {item.wallet_name}
                                                </td>

                                                <td className="p-4">
                                                    {new Date(item.created_at).toLocaleString()}
                                                </td>

                                                <td
                                                    className="
                                    p-4
                                    font-bold
                                    text-green-400
                                    "
                                                >
                                                    ₹
                                                    {
                                                        Number(
                                                            item.grand_total
                                                        ).toFixed(2)
                                                    }
                                                </td>

                                                <td className="p-4">

                                                    <div
                                                        className="
                                        flex
                                        gap-2
                                        flex-wrap
                                        "
                                                    >

                                                        {hasPermission("purchase_return.view") && (
                                                            <>

                                                                <button
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/admin/purchase-returns/view/${item.id}`
                                                                        )
                                                                    }
                                                                    className="
                                            bg-blue-500
                                            px-4
                                            py-2
                                            rounded-xl
                                            "
                                                                >
                                                                    View
                                                                </button>
                                                            </>
                                                        )}

                                                        {hasPermission("purchase_return.delete") && (
                                                            <button
                                                                onClick={() =>
                                                                    deletePurchaseReturn(
                                                                        item.id
                                                                    )
                                                                }
                                                                className="
                                            bg-red-500
                                            px-4
                                            py-2
                                            rounded-xl
                                            "
                                                            >
                                                                Delete
                                                            </button>
                                                        )}

                                                    </div>

                                                </td>

                                            </tr>

                                        )
                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="
                            p-8
                            text-center
                            text-gray-400
                            "
                                        >
                                            No Purchase Returns Found
                                        </td>

                                    </tr>

                                )
                            }

                        </tbody>

                    </table>

                </div>

            </div>

            {/* Pagination */}

            {
                pages > 1 && (

                    <div
                        className="
            flex
            justify-center
            gap-2
            mt-8
            flex-wrap
            "
                    >

                        {
                            Array.from(
                                {
                                    length: pages
                                },
                                (_, index) => (

                                    <button
                                        key={index}
                                        onClick={() =>
                                            setPage(
                                                index + 1
                                            )
                                        }
                                        className={`
                            px-4
                            py-2
                            rounded-xl
                            ${page === index + 1
                                                ? "bg-yellow-500 text-black"
                                                : "bg-[#111]"
                                            }
                            `}
                                    >
                                        {index + 1}
                                    </button>

                                )
                            )
                        }

                    </div>

                )
            }

        </div>

    );

}

export default PurchaseReturns;